import React from 'react';
import PropTypes from 'prop-types';


/**
 * This component replaces nodes in our statically rendered tree which we want to supress the hydration of
 * @param root0
 * @param root0.As
 */
function ServerOnlyReplacementBlock({ As = 'div' }) {
    return (
        <As
            suppressHydrationWarning

            dangerouslySetInnerHTML={{ __html: '' }}
        />
    );
}

ServerOnlyReplacementBlock.propTypes = {
    As: PropTypes.string,
};

ServerOnlyReplacementBlock.blockKey = 'rh/server-rendered-replacement';
// ServerOnlyReplacementBlock.hasHeading = false;
ServerOnlyReplacementBlock.requiresLayoutRow = true;

export default ServerOnlyReplacementBlock;
